import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalBody } from "react-bootstrap";
import isNull from '../../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../../utils/FormValidator';
// import DatePicker from '../../../../../../../../../../General/DatePicker';
import ModalHeader from '../../../../../../../../../../../Setup/Shared/ModalHeader';
import Loader from '../../../../../../../../../../../shared/Loader/Loader';
import DeleteConfirmatiom from '../../../../../../../../../../../General/DeleteConfirmation';
// import SuperSearchList from '../../../../../../../../../../shared/SuperSearch/SuperSearchList';

const AddNewPastSurgeries = (props) => {
    const { isOpenPastSurgeries, onClose, pastSurgeryData, setIsRecordSaved, onDeletePastSurgeries, patientID, IsEditAllowed } = { ...props }
    const API_URL = enumUtil.controller.General
    let PastSurgeries_Modal = {
        Notes: pastSurgeryData.Notes || "",
    }
    let PastSurgeries_Modal_Default = {
        Notes: "",
    }
    let valModal = {}
    let ValidationModal = {
        NotesVal: "",
    }
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
    const [pastSurgeryID, setPastSurgeryID] = useState();
    const [pastSurgeriesValidationModal, setPastSurgeriesValidationModal] = useState(ValidationModal)
    const [pastSurgeriesSaveUpdateModal, setPastSurgeriesSaveUpdateModal] = useState({})
    const [mainPastSurgeriesModal, setMainPastSurgeriesModal] = useState(PastSurgeries_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onPastSurgeriesSaved, setOnPastSurgeriesSaved] = useState(false)
    const [del, setDel] = useState(false)
    const [searchDropdown, setSearchDropdown] = useState(false);
    const [is, setIs] = useState(false);
    console.log("AddNewProblem", props)

    useEffect(() => {
        // setPracticeID(PracticeID)
        if (pastSurgeryData.PatientHistoryID != null) {
            setDel(true)
            setPastSurgeryID(pastSurgeryData.PatientHistoryID)
        } else {
            if (!onPastSurgeriesSaved) {
                setPastSurgeryID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(pastSurgeryID)) {
            // setIsLoading(true)
            // ServerRequestProtected(API_URL + "/FindByID", 'post', {
            //     "ID": pastSurgeryID,
            //     "TableName": enumUtil.enumAPITableName.PastSurgeries
            // }).then((response) => {
            //     setIsLoading(false)
            //     setMainPastSurgeriesModal(response)
            // }).catch((error) => {
            //     NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            //     setIsLoading(false)
            // })
        }
    }, [pastSurgeryID])

    const PastSurgeriesValidation = async () => {
        let ValidationModal = {
            NotesVal: FormValidator(
                mainPastSurgeriesModal.Notes,
                enumUtil.enumValidationType.Required,
                'Notes',
            ),
        }
        await setPastSurgeriesValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const addNewPastSurgeries = () => {
        props.setPastSurgeryData({ PatientHistoryID: null })
        setPastSurgeryID(null)
        handleClear();
    }
    const handleSavePastSurgeries = async (type) => {
        if(!IsEditAllowed) return;
        await PastSurgeriesValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setPastSurgeriesSaveUpdateModal(pastSurgeriesSaveUpdateModal)
            let data = {
                PatientID: patientID,
                HistoryType: "Past Medical History",
                HistorySubType: "Past Surgeries",
                ...pastSurgeriesSaveUpdateModal
            };

            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientHistory,
                ID: pastSurgeryID,
                Data: { ...data },
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        setPastSurgeryID(response.id)
                        setIsRecordSaved(true)
                        setOnPastSurgeriesSaved(true)
                        if (type === "Add Another") {
                            addNewPastSurgeries();
                        } else {
                            onClose();
                        }
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }

    const handleClear = () => {
        setMainPastSurgeriesModal(PastSurgeries_Modal_Default);
        setPastSurgeriesSaveUpdateModal({});
    }
    const handleChange = (e) => {
        let { name, value } = e.target
        let modal = { ...mainPastSurgeriesModal };
        let saveModal = { ...pastSurgeriesSaveUpdateModal }
        modal[name] = value
        setMainPastSurgeriesModal(modal)
        for (var property in PastSurgeries_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setPastSurgeriesSaveUpdateModal(saveModal)
    }

    const handleDeleteModal = () => {
        setisOpenDeleteAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenDeleteAlert(false);
    }
    const onDelete = () => {
        props?.setIsRecordSaved(true);
        setisOpenDeleteAlert(false);
        onClose();
    }

    let DeleteConfirmation = "";
    if (isOpenDeleteAlert) {
        DeleteConfirmation = (
            <DeleteConfirmatiom
                isOpenAlert={isOpenDeleteAlert}
                hideReason={true}
                API_URL={API_URL}
                TableName={enumUtil.enumAPITableName.PatientHistory}
                ID={String(pastSurgeryID)}
                onCloseDelete={onCloseDelete}
                onClose={onDelete}
            />
        );
    }
    let DeletePopup = "";
    if (del) {
        DeletePopup = (
            <button
                className={
                    props?.IsDeleteAllowed
                      ? 
                    "btn-icon-transparent"
                      : 
                      "btn-icon-transparent delete-btn-disabled"
                } onClick={handleDeleteModal}>
                <span className="icon"><i className="icon-delete"></i></span>
                <span className="title">Delete</span>
            </button>
        );
    }


    const PastSurgeriesName = () => {
        return (
            <p className="heading">Past Medical History</p>
        )
    }
    const textareaRef = useRef(null);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.setProperty('height', 'auto', 'important');
            textarea.style.setProperty('height', `${textarea.scrollHeight}px`, 'important');
        }
    };
    useEffect(() => {
        adjustTextareaHeight();
    }, [mainPastSurgeriesModal.Notes]);
    return (
        <Modal show={isOpenPastSurgeries} onHide={isOpenPastSurgeries} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
            <Modal.Body>
                {DeleteConfirmation}
                {isLoading ? <Loader /> : null}
                <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={PastSurgeriesName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
                <div className="">
                    <div className=''>
                        <div className={`input my-2 ${pastSurgeriesValidationModal.NotesVal ? 'error' : ''}`}>
                            <label className="pb-3px">Past Surgeries</label>
                            <textarea
                                className="form-control overflow-hidden"
                                ref={textareaRef}
                                onInput={adjustTextareaHeight}
                                id='Notes'
                                name='Notes'
                                rows="3"
                                onChange={handleChange}
                                value={mainPastSurgeriesModal.Notes}
                            ></textarea>
                            {pastSurgeriesValidationModal.NotesVal}
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <div className="d-flex align-items-center gap-2">
                <button className={`btn btn-outline  px-10 h-100 validate-color ${IsEditAllowed ? '' : 'disable'}`} onClick={() => handleSavePastSurgeries("Add Another")}>Save & Add Another</button>
                <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSavePastSurgeries}>Save</button>
                </div>
            </div>
        </Modal>
    )
}

export default AddNewPastSurgeries